import React, { useEffect, useState } from 'react'
import Layout from "../../layout/Layout";
import CustomFormInput from "../CustomFormInput";
import { Col, Form, Row } from 'react-bootstrap';
import MultipleSelectDropdown from '../MultipleSelectDropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import { EventValidation } from '../../validate/eventValidation';
import ErrorFilter from '../../helper/errorFilter';
import SingleError from '../../helper/SingleError';
import { getUser, updateEvent, getAllSkill, getAllActivityList } from '../../controller';
import { toast } from 'react-toastify';
import { requestHandler } from '../../helper';
import Loader from '../Loader';

function EditEvent() {
  const location = useLocation();
  const editEvent = location.state?.event || {}
  const id = editEvent?.userId?._id
  const [userData, setUserData] = useState([]);
  const [skillData, setSkillData] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [submitCount, setSubmitCount] = useState(0)
  const [errors, setErrors] = useState();
  const localDate = new Date(editEvent.eventDate).toISOString().split('T')[0];
  const localTime = new Date(editEvent.eventDate).toTimeString().split(' ')[0].slice(0, 5);
  const requireField = ["eventName", "firstName", "lastName", "eventTime", "eventDate", "location", "description", "communityName", "activities", "limit"];
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [event, setEvent] = useState({
    eventName: editEvent?.eventName,
    firstName: editEvent?.userId?.firstName,
    lastName: editEvent?.userId?.lastName,
    limit: editEvent?.limit,
    eventTime: localTime,
    eventDate: localDate,
    location: editEvent?.location,
    description: editEvent?.description,
    attendees: editEvent.attendees?.length
      ? editEvent.attendees?.map((item) => ({
        label: item?.userName,
        value: item?._id
      })) : [],
    communityName: editEvent?.communityId?.name,
    eventType: editEvent?.eventType,
    activities: editEvent?.activities?.length
      ? editEvent.activities?.map((item) => ({
        label: item?.title,
        value: item?._id
      }))
      : [],
    skill: editEvent.skill?.length
      ? editEvent.skill?.map((item) => ({
        label: item?.name,
        value: item?._id
      }))
      : [],
  });


  const getUserData = async () => {
    await requestHandler(
      async () => await getUser(id),
      null,
      (res) => {
        setUserData(res.data);
      },
      () => { }
    )
  };

  const getSkillData = async () => {
    await requestHandler(
      async () => await getAllSkill(),
      null,
      (res) => {
        setSkillData(res.data || []);
      },
      () => { }
    )
  };

  const getActivityData = async () => {
    await requestHandler(
      async () => await getAllActivityList(),
      null,
      (res) => {
        setActivityData(res.data || []);
      },
      () => { }
    )
  };

  useEffect(() => {
    getUserData();
    getSkillData();
    getActivityData();
    // eslint-disable-next-line
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (submitCount > 0) {
      let validationError = EventValidation({
        ...event,
        [name]: value
      });
      validationError = ErrorFilter(validationError, requireField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors[name];
      }
    }
    setEvent({ ...event, [name]: value });
  };

  const handleAttendeeChange = (e) => {
    if (submitCount > 0) {
      let validationError = EventValidation({
        ...event,
        attendees: e
      });
      validationError = ErrorFilter(validationError, requireField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors.attendees;
      }
    }
    setEvent((prev) => ({ ...prev, attendees: e }))
  }

  const handleActivityChange = (e) => {
    if (submitCount > 0) {
      let validationError = EventValidation({
        ...event,
        activities: e
      });
      validationError = ErrorFilter(validationError, requireField);
      setErrors(validationError);
      if (Object.keys(validationError).length === 0) {
        delete errors.activities;
      }
    }
    setEvent((prev) => ({ ...prev, activities: e }))
  }
  const handleEventTypeChange = (newValue) => {
    // Convert the string back to a number if needed
    const updatedEventType = Number(newValue);
    // Update the event object or state with the new value
    setEvent(prevEvent => ({ ...prevEvent, eventType: updatedEventType }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSubmitCount(prevCount => prevCount + 1);
    const updatedValues = { ...event, skill: event.skill.map((item) => item.value), activities: event.activities.map((item) => item.value), attendees: event.attendees.map((item) => item.value) };
    let validationErrors = EventValidation(updatedValues);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      if (event.eventTime || event.eventDate) {
        const selectedDateTime = new Date(`${event.eventDate} ${event.eventTime}`);
        const now = new Date();
        
        // Check if selected date/time is in the past
        if (selectedDateTime < now) {
          toast.error('Event date and time cannot be in the past');
          return;
        }
        
        updatedValues.eventDate = selectedDateTime.toISOString();
      }
      await requestHandler(async () => await updateEvent(updatedValues, editEvent._id),
        setLoading,
        (res) => {
          toast.success(res.message);
          navigate("/category-management");
        },
        () => { });

    }
  };



  return (
    <>
      {loading && <Loader />}
      <Layout>
        <div className="card-wrapper label-dark">
          <div className="card-body">
            <div className='border-bottom pb-3 mb-3'>
              <h5 className='fs-18 fw-600'>Update Data</h5>
            </div>
            <Row>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="text"
                  label="Event Name"
                  placeholder="Enter event name"
                  id="eventName"
                  name="eventName"
                  value={event.eventName}
                  onChange={handleChange}
                />
                <SingleError error={errors?.eventName} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="text"
                  label="First Name"
                  placeholder="Enter firstname"
                  id="firstName"
                  name="firstName"
                  value={event.firstName}
                  onChange={handleChange}
                  disabled
                />
                <SingleError error={errors?.firstName} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="text"
                  label="Last Name"
                  placeholder="Enter lastname"
                  id="lastName"
                  name="lastName"
                  value={event.lastName}
                  onChange={handleChange}
                  disabled
                />
                <SingleError error={errors?.lastName} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="time"
                  label="Event Time"
                  id="eventTime"
                  name="eventTime"
                  value={event.eventTime}
                  onChange={handleChange}
                />
                <SingleError error={errors?.eventTime} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="date"
                  label="Event Date"
                  id="eventDate"
                  name="eventDate"
                  value={event.eventDate}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                />
                <SingleError error={errors?.eventDate} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="text"
                  label="Location"
                  placeholder="Enter location"
                  id="location"
                  name="location"
                  value={event.location}
                  onChange={handleChange}
                />
                <SingleError error={errors?.location} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <div className='theme-select theme-input'>
                  <Form.Label>Event Type</Form.Label>
                  <Form.Select
                    value={String(event.eventType)} // Ensure the value is a string, since the <option> values are strings
                    onChange={e => handleEventTypeChange(e.target.value)}
                  >
                    <option value="0">Private</option>
                    <option value="1">Public</option>
                  </Form.Select>
                </div>
              </Col>

              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="text"
                  label="Community Name"
                  placeholder="Enter community name"
                  id="communityName"
                  name="communityName"
                  value={event.communityName}
                  onChange={handleChange}
                  disabled
                />
                <SingleError error={errors?.communityName} />
              </Col>
              <Col xs={12}>
                <CustomFormInput
                  rows={3}
                  as="textarea"
                  type="text"
                  label="Event Description"
                  placeholder="Enter description"
                  id="description"
                  name="description"
                  value={event.description}
                  onChange={handleChange}
                />
                <SingleError error={errors?.description} />
              </Col>


              <Col md={4} sm={6}>
                <div className='theme-input'>
                  <Form.Label>Total  Attendees</Form.Label>
                  <MultipleSelectDropdown options={userData?.map(user => ({ label: user.userName, value: user._id }))} value={event.attendees} onChange={handleAttendeeChange}
                  />
                </div>
                <SingleError error={errors?.attendees} />
              </Col>
              <Col xxl={3} md={4} sm={6}>
                <CustomFormInput
                  type="number"
                  label="Number of attendees"
                  placeholder="Enter number of attendees"
                  id="limit"
                  name="limit"
                  value={event.limit}
                  onChange={handleChange}
                />
                <SingleError error={errors?.limit} />
              </Col>

              <Col md={4} sm={6}>
                <div className='theme-input'>
                  <Form.Label>Activities</Form.Label>
                  <MultipleSelectDropdown options={activityData?.map(activity => ({ label: activity.title, value: activity._id }))} value={event.activities} onChange={handleActivityChange} />
                </div>
                {/* <SingleError error={errors?.activities} /> */}
              </Col>
              <Col md={4} sm={6}>
                <div className='theme-input'>
                  <Form.Label>Skills Level</Form.Label>
                  <MultipleSelectDropdown options={skillData?.map(skill => ({ label: skill.name, value: skill._id }))} value={event.skill} onChange={(e) => setEvent((prev) => ({ ...prev, skill: e }))} />
                </div>
              </Col>
            </Row>
            <div className='d-flex justify-content-end gap-2 mt-2'>
              <button className='btn btn-outline-light' onClick={() => navigate("/category-management")}>Cancel</button>
              <button className='btn btn-primary' type='button' onClick={handleSave}>Save Changes</button>
            </div>
          </div>
        </div>
      </Layout >
    </>
  )
}

export default EditEvent